<template>
  <li class="tc-main-nav-item p-2 pb-4 sm:pb-2 lg:px-6">
    <router-link
      class="inline-block duration-150 underline-from-center"
      active-class="tc-nav-route-match"
      exact-active-class="tc-nav-route-exact"
      :class="{ 'router-link-active': onPage }"
      v-bind="$attrs"
    >
      <slot />
    </router-link>
  </li>
</template>

<script>
// A menu item shows as current only on its own page, not on the pages inside it
// (a report opened from Results sits under /client-assessments). The query is
// ignored so filtered views, like archived assessments, still count.
export default {
  inheritAttrs: false,
  computed: {
    onPage() {
      return this.$router.resolve(this.$attrs.to).route.path === this.$route.path
    }
  }
}
</script>
